/**
 * av 初始化
 * */
define(function(require) {
    var XLSX = require("xlsx");
    var Deferred = require('./deferred')
    return {
        toExecl: toExecl,
        importExecl: importExecl
    }

    //数据示例
    //var ss = {
    //    SheetName: "报告会口令", 文件名字
    //    data: {
    //        Head: [["head1", "head2"], ["head3", "head4"]], 头部标题 如只有一个 就全一样
    //        Sheets: ["11", "22"], //工作薄 名称
    //        List: [list, list],//数据 对象数组
    //    }
    //}

    function toList(head, list) {
        console.log(head, list);
        var result = [];
        var qw = [];
        qw.push(head);
        for (var i in list) {
            var m = list[i];
            var d = [];
            for (var j in m) {
                d.push(m[j]);
            }
            result.push(d);
        }
        return qw.concat(result);
    }

    function toExecl(obj) {
        var SheetNames = [];
        var Sheets = new Object();
        for (var i = 0; i < obj.data.Sheets.length; i++) {
            // debugger
            SheetNames.push(obj.data.Sheets[i]);
            if (obj.data.Head.length == 1) {
                Sheets[obj.data.Sheets[i]] = XLSX.utils.aoa_to_sheet(toList(obj.data.Head[0], obj.data.List[i]));
            } else {
                var r = toList(obj.data.Head[i], obj.data.List[i])
                    // console.log(r);
                Sheets[obj.data.Sheets[i]] = XLSX.utils.aoa_to_sheet(r);
            }
        }
        var tmpWB = {
            SheetNames: SheetNames, //保存的表标题
            Sheets: Sheets
        }

        // console.log(tmpWB);
        var tmpDown = new Blob([s2ab(XLSX.write(tmpWB, { bookType: 'xlsx', bookSST: false, type: 'binary' }))], {
            type: ""
        });
        var href = URL.createObjectURL(tmpDown);
        var newa = document.getElementById("Execl")
        if (!newa) {
            newa = document.createElement("a");
            newa.id = "Execl";
        }
        newa.href = href;
        newa.download = obj.SheetName + ".xlsx";
        document.body.appendChild(newa);
        document.getElementById("Execl").click();
        setTimeout(function() {
            //释放
            URL.revokeObjectURL(tmpDown);
        }, 100);
    }

    //导入
    function importExecl(obj) {
        var df = Deferred();
        try {
            var wb = null;
            var rABS = false;
            if (!obj.files) {
                return;
            }
            var f = obj.files[0];
            var reader = new FileReader();
            reader.onload = function(e) {
                var data = e.target.result;
                if (rABS) {
                    wb = XLSX.read(btoa(fixdata(data)), { //手动转化
                        type: 'base64'
                    });
                } else {
                    wb = XLSX.read(data, {
                        type: 'binary'
                    });
                }
                /**
                 * wb.SheetNames[0]是获取Sheets中第一个Sheet的名字
                 * wb.Sheets[Sheet名]获取第一个Sheet的数据
                 */
                var excelJson = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
                df.resolve(excelJson);
            };
            if (rABS) {
                reader.readAsArrayBuffer(f);
            } else {
                reader.readAsBinaryString(f);
            }
        } catch (e) {
            df.reject(e);
        }
        return df;
    }

    //文件流转BinaryString
    function fixdata(data) {
        var o = "",
            l = 0,
            w = 10240;
        for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
        o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
        return o;
    }

    function s2ab(s) { //字符串转字符流
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
});